// extracted by mini-css-extract-plugin
export default {"toggleList":"toggleList__koUkH","item":"item__30DuY","narrow":"narrow__bhfBd"};